// extracted by mini-css-extract-plugin
export default {"root":"SharingPublicThemeTariffsModal__root--3JCku","title":"SharingPublicThemeTariffsModal__title--1_rS_"};